import { Doc } from "@/components/Doc/Doc";
import { FlashOnChangeTD } from "@/components/FlashOnChange/FlashOnChange";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { manifest } from "@/docs/manifest";
import { InvestorDistributionTable } from "@/financeModels/owasco/returnMetrics";
import { monospaceFontFamily, textFontFamily } from "@/theme";
import { formatMoney } from "@/utils/moneyFormating";
import { Table } from "@mantine/core";

export const InvestorDistributionsTable = ({
  table,
}: {
  table: InvestorDistributionTable;
}) => {
  const cols: {
    title: string;
    field: keyof InvestorDistributionTable;
    docPath?: keyof typeof manifest;
  }[] = [
    {
      title: "Period",
      field: "periods",
      docPath: "@/docs/pages/model/roi/id-period.mdx",
    },
    {
      title: "Year",
      field: "years",
      docPath: "@/docs/pages/model/roi/id-year.mdx",
    },
    {
      title: "Preferred\nDividends",
      field: "preferredDividends",
      docPath: "@/docs/pages/model/roi/id-preferred-divdends.mdx",
    },
    {
      title: "Principal\nRepayments",
      field: "principalRepayments",
      docPath: "@/docs/pages/model/roi/id-principal-repayments.mdx",
    },
    {
      title: "Profit\nDistributions",
      field: "profitDistributions",
      docPath: "@/docs/pages/model/roi/id-profit-distributions.mdx",
    },
    {
      title: "Tax\nDistributions",
      field: "taxDistributions",
      docPath: "@/docs/pages/model/roi/id-tax-distributions.mdx",
    },
    {
      title: "Net Sale\nProceeds",
      field: "proceedsFromCompanySale",
      docPath: "@/docs/pages/model/roi/id-sale-proceeds.mdx",
    },
    {
      title: "Total Investor\nDistributions",
      field: "totalInvestorDistributions",
      docPath: "@/docs/pages/model/roi/id-total-investor-distrubutions.mdx",
    },
  ] as const;

  const rows = [
    ...table.periods.map((period, i) => ({
      period,
      year: table.years[i],
      preferredDividends: table.preferredDividends[i],
      principalRepayments: table.principalRepayments[i],
      profitDistributions: table.profitDistributions[i],
      taxDistributions: table.taxDistributions[i],
      proceedsFromCompanySale: table.proceedsFromCompanySale[i],
      totalInvestorDistributions: table.totalInvestorDistributions[i],
    })),
    {
      period: "",
      year: "Total",
      ...table.totals,
    },
  ] as const;

  return (
    <Table striped withColumnBorders flex={1}>
      <Table.Thead
        style={{
          position: "sticky",
          top: "0",
          background: "white",
        }}
      >
        <Table.Tr>
          {cols.map((col) => (
            <Table.Th
              ta={"center"}
              key={col.field}
              style={{
                whiteSpace: "pre-wrap",
              }}
            >
              <LabelExplainer
                lh={1.6}
                justify="center"
                label={col.title}
                explanation={col.docPath ? <Doc path={col.docPath} /> : null}
              />
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody ff={monospaceFontFamily}>
        {rows.map((row, i) => (
          <Table.Tr
            key={row.period}
            bg={i === rows.length - 1 ? "infomatic.0" : ""}
            fw={i === rows.length - 1 ? "bold" : ""}
          >
            <Table.Td ta={"center"} ff={textFontFamily}>
              {row.period}
            </Table.Td>
            <Table.Td ta={"center"}>{row.year}</Table.Td>

            {cols
              .filter((col) => col.field !== "periods" && col.field !== "years")
              .map((col) => (
                <FlashOnChangeTD
                  key={col.field}
                  content={row[col.field as keyof typeof row]?.toString()}
                  ta={"right"}
                  miw={140}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {formatMoney(Number(row[col.field as keyof typeof row]) || 0)}
                </FlashOnChangeTD>
              ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
